var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "12 12 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-width:0.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1262",
    "data-name": "Group 1262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    className: "cls-1",
    d: "M53,21.7a11.42,11.42,0,0,0-16.15-.19l-.1.09-1.11,1.12L34.5,21.6A11.42,11.42,0,0,0,18.36,37.74L32.64,52a4.23,4.23,0,0,0,6,0L52.8,37.84A11.53,11.53,0,0,0,53,21.7ZM51.3,36.35,37.11,50.53a2.11,2.11,0,0,1-3,0L19.85,36.26A9.31,9.31,0,0,1,33,23.1l1.11,1.11-1.71,1.71a1.05,1.05,0,0,0,1.49,1.49l4.32-4.32a9.31,9.31,0,0,1,13.16,0l.07.08A9.39,9.39,0,0,1,51.3,36.35Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1265",
    "data-name": "Group 1265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1264",
    "data-name": "Group 1264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    className: "cls-1",
    d: "M50.24,31.47a7.72,7.72,0,0,0-5.62-7,1.06,1.06,0,0,0-1.31.73,1.07,1.07,0,0,0,.74,1.31h0a5.6,5.6,0,0,1,4.08,5,1,1,0,0,0,1,1h.07A1.05,1.05,0,0,0,50.24,31.47Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon);
export default __webpack_public_path__ + "static/media/social-icon.8730336f4f76a01625e0cf86f84ab734.svg";
export { ForwardRef as ReactComponent };